import {
    Typography,
    Grid,
    useTheme,
    Box,
    IconButton,
} from '@mui/material'
import { KeyboardArrowRight } from '@mui/icons-material';
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';
import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import ContactsDialog from '../../../components/ContactsDialog';
import HideForms from '../../../components/SendPulseForms/hide';
import { donate } from '../../../assets/links';
import DonateDialog from '../../../components/DonateDialog/DonateDialog';




const ContactsPage = () => {
    const { palette } = useTheme();
    const navigate = useNavigate();

    const [contactsOpen, setContactsOpen] = useState<boolean>(false);
    const [donateOpen, setDonateOpen] = useState<boolean>(false);

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Контакти", urlSlug: "" },
    ]);

    useEffect(() => {
        document.title = `Контакти`;

    }, [])

    return (
        <>
            <HideForms />
            <Box sx={{ my: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "28px", md: "0px" } }}>
                <BreadcrumbsComponent elements={breadcrumbs} />
            </Box>
            <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", md: "24px", lg: "36px" }} lineHeight="38px"  >
                Контакти
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", mt: { xs: "14px", lg: "38px" }, mb: { xs: "43px", lg: "120px" } }}>
                <Box
                    sx={{
                        background: palette.primary.dark,
                        width: { xs: "350px", lg: "718px" },
                        height: { xs: "202px", md: "417px", lg: "654px" },
                        borderRadius: { xs: "10px", lg: "20px" },
                        p: { xs: "18px 40px 0px 26px", md: "18px 50px 0px 16px", lg: "35px 38px 0px 33px" },
                        position: "relative",
                        cursor: "pointer"
                    }}
                    onClick={() => setDonateOpen(true)}
                >
                    <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "21px", lg: "38px" }} color="inherit" fontWeight="bold" sx={{ fontSize: { xs: "16px", md: "18px", lg: "h3.fontSize" } }}>
                        Підтримай нас тут
                    </Typography>
                    <Typography variant="h3" fontFamily="Fixel Display, sans-serif" lineHeight={{ xs: "22px", lg: "38px" }} color={palette.text.secondary} fontWeight="600" sx={{ fontSize: { xs: "16px", lg: "h3.fontSize" }, mt: { xs: "6px", lg: "12px" } }}>
                        Твій внесок може допомогти розвитку нашої організації.
                    </Typography>
                    <IconButton disableRipple size="large" sx={{ position: "absolute", width: { xs: "24px", lg: "48px" }, height: { xs: "24px", lg: "48px" }, right: { xs: "28px", lg: "56px" }, bottom: { xs: "18px", md: "16px", lg: "44px" }, border: { xs: `2px solid #fff`, lg: `3px solid #fff` }, p: "0px" }}>
                        <KeyboardArrowRight fontSize="inherit" sx={{ width: { xs: "20px", lg: "48px" }, height: { xs: "20px", lg: "48px" } }} />
                    </IconButton>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <Box
                        sx={{
                            background: palette.text.secondary,
                            width: { xs: "350px", lg: "574px" },
                            height: { xs: "202px", md: "200px", lg: "318px" },
                            borderRadius: { xs: "20px", lg: "30px" },
                            p: { xs: "19px 16px 0px 26px", lg: "31px 26px 0px 41px" },
                            position: "relative",
                            cursor: "pointer",
                            my: { xs: "14px", md: "0px" }
                        }}
                        onClick={() => setContactsOpen(true)}
                    >
                        <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "21px", lg: "38px" }} color="primary.dark" fontWeight="bold" sx={{ fontSize: { xs: "16px", md: "18px", lg: "h3.fontSize" } }}>
                            Знайди нас тут!
                        </Typography>
                        <Typography variant="h4" fontFamily="Fixel Display, sans-serif" lineHeight={{ xs: "22px", lg: "28px" }} color={palette.background.default} fontWeight="600" sx={{ fontSize: { xs: "16px", lg: "h4.fontSize" }, mt: { xs: "6px", lg: "12px" } }}>
                            Слідкуйте за нами в соцмережах, та будьте поінформованими про всі актуальні події
                        </Typography>
                        <IconButton disableRipple size="large"
                            sx={{
                                color: palette.background.default,
                                position: "absolute",
                                width: { xs: "30px", lg: "48px" },
                                height: { xs: "30px", lg: "48px" },
                                right: { xs: "20px", lg: "32px" }, bottom: { xs: "17px", lg: "26px" },
                                border: `3px solid ${palette.background.default}`,
                                p: "0px"
                            }}>
                            <KeyboardArrowRight fontSize="inherit" sx={{ width: { xs: "30px", lg: "48px" }, height: { xs: "30px", lg: "48px" } }} />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            background: palette.text.secondary,
                            width: { xs: "350px", lg: "574px" },
                            height: { xs: "202px", md: "200px", lg: "318px" },
                            borderRadius: { xs: "20px", lg: "30px" },
                            p: { xs: "19px 16px 0px 26px", lg: "31px 26px 0px 41px" },
                            position: "relative",
                            cursor: "pointer"
                        }}
                        onClick={() => { navigate("/for-partners"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    >
                        <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "21px", lg: "38px" }} color="primary.dark" fontWeight="bold" sx={{ fontSize: { xs: "16px", md: "18px", lg: "h3.fontSize" } }}>
                            Давай співпрацювати!
                        </Typography>
                        <Typography variant="h4" fontFamily="Fixel Display, sans-serif" lineHeight={{ xs: "22px", lg: "28px" }} color={palette.background.default} fontWeight="600" sx={{ fontSize: { xs: "16px", lg: "h4.fontSize" }, mt: { xs: "6px", lg: "12px" } }}>
                            Ми відкриті до нових партнерств. Разом ми зможемо зробити більше!
                        </Typography>
                        <IconButton
                            disableRipple
                            size="large"
                            sx={{
                                color: palette.background.default,
                                position: "absolute",
                                width: { xs: "30px", lg: "48px" },
                                height: { xs: "30px", lg: "48px" },
                                right: { xs: "20px", lg: "32px" }, bottom: { xs: "17px", lg: "26px" },
                                border: `3px solid ${palette.background.default}`,
                                p: "0px"
                            }}
                        >
                            <KeyboardArrowRight fontSize="inherit" sx={{ width: { xs: "30px", lg: "48px" }, height: { xs: "30px", lg: "48px" } }} />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
            <ContactsDialog open={contactsOpen} handleClose={() => setContactsOpen(false)} />
            <DonateDialog open={donateOpen} handleClose={() => setDonateOpen(false)} />
        </>
    )
}

export default ContactsPage